import React from 'react'

const StaffMember = ({ jobTitle, title, email, category }) => {
  return (
    <tr>
      <td>
        {title}
      </td>
      <td>
        {category}
      </td>
      <td>
        {jobTitle}
      </td>
    </tr>
  )
}

export default StaffMember
